module.exports = "/_next/static/images/calculatoralt-9660a8961136a72c77838b5c90f5a22f.svg";